import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Frieze',
    description: 'A design studio working in identity, typeface design, editorial and wayfinding.',
    url: getOrigin()
}

export const studio = {
    founded: '2016',
    cities: ['London', 'Lisbon'],
    people: '9',
    email: 'studio@frieze.design',
    telephone: '+44 20 7946 0311',
    address: 'Unit 4, Bermondsey Wall, London SE16',
    instagram: '@frieze.design',
    instagramUrl: 'https://instagram.com',
    timeZone: 'Europe/Lisbon',
    timeCity: 'Lisbon'
}
